import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Star } from 'lucide-react';
export function Pricing() {
  return <section id="pricing" className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-162">
      <div className="text-center mb-16" data-id="element-163">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-164">
          💳 ELEGÍ TU MEGAPACK IA
        </h2>
      </div>

      <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-165">
        {/* Standard Plan */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} whileHover={{
        y: -5
      }} className="bg-brand-dark border border-brand-violet/30 rounded-3xl p-8 flex flex-col relative" data-id="element-166">
          <div className="mb-8" data-id="element-167">
            <h3 className="text-2xl font-bold text-white mb-2 flex items-center gap-2" data-id="element-168">
              📘 MEGAPACK IA EMPRENDEDORES
            </h3>
            <p className="text-brand-violet font-medium mb-4" data-id="element-169">
              6 Tomos + 6 Bonos
            </p>
            <p className="text-gray-400 text-sm" data-id="element-170">
              Ideal para: Emprendedores que quieren implementar IA en su negocio
              hoy
            </p>
          </div>

          <div className="mb-8" data-id="element-171">
            <p className="text-gray-500 line-through text-lg mb-1" data-id="element-172">
              $97.000 ARS
            </p>
            <div className="flex items-baseline gap-2" data-id="element-173">
              <span className="text-5xl font-bold text-white" data-id="element-174">$19.990</span>
              <span className="text-gray-400" data-id="element-175">ARS</span>
            </div>
          </div>

          <a href="https://www.blibliotecadigital.com/checkouts/cn/hWNCaCwWszUXwycjdCdacmN0/es-ar?_r=AQABiTR50XPJ3EFra31hpbxsy3-amqMVHrvTLXDVEI3PWd8&cart_link_id=OdLORxfb&preview_theme_id=152474878124" target="_blank" rel="noopener noreferrer" className="w-full py-4 px-6 rounded-xl bg-brand-violet hover:bg-purple-600 text-white font-bold text-center transition-colors mt-auto" data-id="element-176">
            → QUIERO MI MEGAPACK IA
          </a>
        </motion.div>

        {/* Pro Plan */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} whileHover={{
        y: -5
      }} className="bg-gradient-to-b from-brand-violet/20 to-brand-dark border-2 border-brand-gold rounded-3xl p-8 flex flex-col relative shadow-[0_0_30px_rgba(212,160,23,0.15)]" data-id="element-177">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-brand-gold text-brand-dark font-bold px-4 py-1 rounded-full text-sm flex items-center gap-1 shadow-lg" data-id="element-178">
            <Star className="w-4 h-4 fill-brand-dark" data-id="element-179" /> RECOMENDADO
          </div>

          <div className="mb-8" data-id="element-180">
            <h3 className="text-2xl font-bold text-white mb-2 flex items-center gap-2" data-id="element-181">
              🏆 MEGAPACK IA + SISTEMA EMPRESARIO PRO
            </h3>
            <p className="text-brand-gold font-medium mb-4" data-id="element-182">
              6 Tomos + 6 Bonos + Sistema Empresario Pro
            </p>
            <p className="text-gray-300 text-sm" data-id="element-183">
              Ideal para: Emprendedores que quieren ir más allá de las
              herramientas y construir un negocio que funcione solo
            </p>
          </div>

          <div className="mb-8" data-id="element-184">
            <p className="text-gray-500 line-through text-lg mb-1" data-id="element-185">
              $147.000 ARS
            </p>
            <div className="flex items-baseline gap-2" data-id="element-186">
              <span className="text-5xl font-bold text-brand-gold" data-id="element-187">
                $27.990
              </span>
              <span className="text-gray-400" data-id="element-188">ARS</span>
            </div>
          </div>

          <a href="https://www.blibliotecadigital.com/checkouts/cn/hWNCaDEnKQSN8Wr6n1ZoGkU6/es-ar?_r=AQABSJqOC0Gp5UKDa1_jGXy8hGHBCYfo3JJhMuTFYkUMqms&cart_link_id=ozqW5EWo&preview_theme_id=152474878124" target="_blank" rel="noopener noreferrer" className="w-full py-4 px-6 rounded-xl bg-brand-gold hover:bg-yellow-500 text-brand-dark font-bold text-center transition-colors mt-auto shadow-[0_0_20px_rgba(212,160,23,0.3)]" data-id="element-189">
            → QUIERO EL MEGAPACK + SISTEMA PRO
          </a>
        </motion.div>
      </div>
    </section>;
}